import React, { Component } from 'react'
import { useNavigate, Link, json } from "react-router-dom";
import { GetFooterDetails } from "../../Services/UtilitiesServices";
class Hotel extends Component {

  constructor(props) {
    super(props);
    this.state = {
      contactNo: "",
      email: "",   

    };
  }

    componentDidMount() {
  
      this.fetchFooter();
  
      
      this.interval = setInterval(() => {
        const currentCountry = localStorage.getItem("selectedCountryCode");
  
        if (currentCountry !== this.state.country) {
          this.setState({ country: currentCountry }, () => {
            this.fetchFooter();
          });
        }
      }, 500);
  
    }

    componentWillUnmount() {
        clearInterval(this.interval);
      }
    
    fetchFooter = async () => {
        try {
          //console.log("Calling API for country:", this.state.country);
          const res = await GetFooterDetails();
          this.setState({ email: res.data.b2CEmail,contactNo: res.data.b2CContactNo });
        } catch (error) {
          console.error("Footer API error:", error);
        }
      };

  render() {
    return (
      <div>
       <div className="container">
        <h2 class="mb-2 mx-2 cs-title mt-5 text-center">Launching soon!</h2>
        <p className="cs-text text-center">We are currently developing the system for a better experience.<br/>Apologize for the inconvenience and thank you.</p>
        <div className="row align-items-center justify-content-center">
        <div className="col-lg-4 col-md-4">
       
        <img src="assets/img/hotel-bg.webp" className="img-fluid" />
        </div>
        <div className="col-lg-6 col-md-6">
        <div className="card cs-card">
          <div className="card-title">
          <h4>For Hotel Booking and Enquiries Please contact us </h4>
          </div>
          <div className="card-body">
         
          <h4><img src="assets/img/support.svg" width={30}/> {this.state.contactNo || "Loading..."}</h4>
        <h4><img src="assets/img/email.svg" width={30}/> {this.state.email || "Loading..."}</h4>
          </div>
        </div>
        </div>
        </div>

        </div>
      
      </div>
    )
  }
}

function WithNavigate(props) {
    let navigate = useNavigate();
    return <Hotel {...props} navigate={navigate} />;
  }
  
  export default WithNavigate;
